import type {
  CheckoutResult,
  LedgerEntryView,
  PaymentView,
  UnitPackageView,
  WalletView,
} from '@alterium/shared';
import { api, apiRequestWithMeta } from './client';

export const walletApi = {
  balance: () => api.get<WalletView>('/wallet'),

  ledger: (cursor?: string) =>
    apiRequestWithMeta<LedgerEntryView[]>({
      method: 'GET',
      url: '/wallet/ledger',
      params: { limit: 30, ...(cursor ? { cursor } : {}) },
    }),

  packages: () => api.get<UnitPackageView[]>('/billing/packages'),
  payments: () => api.get<PaymentView[]>('/billing/payments'),
  checkout: (packageId: string) => api.post<CheckoutResult>('/billing/checkout', { packageId }),

  /** Только вне продакшна: заменяет вебхук платёжного шлюза. */
  mockPay: (paymentId: string) => api.post<PaymentView>('/billing/mock-pay', { paymentId }),
};
